import { Dispatch, ThunkAction } from '../../../types/actions';
import { IGetState } from '../../../types/types';
import { getAuthUser } from '../../../store/model/authUser/selectors/getAuthUser';
import { IAuthUser } from '../../../store/model/authUser/types';
import { authUserPatch } from './api/helper/authUserPatch';
import { IPromoCode } from '../../../types/rest/IUserMeta';

export const authUserSetPromoCode = (
    promoCode: IPromoCode,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const authUser = getAuthUser(getState());
        const userPatch: IAuthUser = {
            id: authUser.id,
            meta: {
                promoCode
            }
        };
        return dispatch(authUserPatch(userPatch));
    };
    return action;
};
